import CashierBranchesModal from "@/components/Cashier/CashierBranchesModal";
import CashierCart from "@/components/Cashier/CashierCart";
import CashierNavBar from "@/components/Cashier/CashierNavBar";
import { Alert, AlertDescription, AlertTitle } from "@/components/ui/alert";
import { useSidebar } from "@/contexts/SidebarContext";
import useLockBodyScroll from "@/hooks/useLockBodyScroll";
import { useUserRole } from "@/hooks/useUserRole";
import { clearBranch, setBranch } from "@/store/BranchSlice";
import { RootState } from "@/store/store";
import { ProductBranch } from "@/types/globalTypes";
import axios from "axios";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";

function Cashier() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const {isShowingIconsOnly} = useSidebar()

  const [branchModalOpen, setBranchModalOpen] = useState(false);
  const [taxesActive, setTaxesActive] = useState(false);
  const [branches, setBranches] = useState<ProductBranch[]>([]);
  const baseUrl = import.meta.env.VITE_BASE_URL;
  const token = useSelector(
    (state: { auth: { token: string } }) => state.auth.token,
  );
  const dispatch = useDispatch();
  const branch = useSelector((state: RootState) => state.branch.branch);
  const [selectedBranch, setSelectedBranch] = useState<ProductBranch | null>(
    null,
  );
  const apps = useSelector((state: RootState) => state.apps.AppsData);
  const cashierApp = apps?.find((app) => app.name === "cashier");
  const { isCashier } = useUserRole();

  useLockBodyScroll(branchModalOpen);


  async function getBranches() {
    try {
      const options = {
        url: `${baseUrl}/api/dashboard/branches/list`,
        method: "GET",
        headers: {
          Authorization: token,
        },
      };
      const response = await axios.request(options);
      setBranches(response.data.branches);
    } catch (error) {
      console.error(error);
    }
  }
  useEffect(() => {
    if (!branch || !branches?.length) return;

    const currentBranch = branches.find(
      (e) => String(e._id) === String(branch._id),
    );
    if (currentBranch?.availability === 0) {
      setSelectedBranch(currentBranch);
      dispatch(setBranch(currentBranch));
    } else {
      setSelectedBranch(null);
      dispatch(clearBranch());
      setBranchModalOpen(true);
    }
  }, [branch, branches, dispatch]);

  useEffect(() => {
    getBranches();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  useEffect(() => {
    if ((cashierApp?.available && cashierApp?.installed) || isCashier) {
      return;
    } else {
      navigate("/notfound");
    }
  }, [cashierApp, isCashier, navigate]);

  useEffect(() => {
    if (!branch) {
      setBranchModalOpen(true);
    }
  }, [branch]);

  if ((!cashierApp?.available || !cashierApp?.installed) && !isCashier) {
    return null;
  }

  if ((!cashierApp?.available || !cashierApp?.installed) && isCashier) {
    return (
      <>
        <Alert className="border-none bg-yellow-400 text-yellow-800 dark:border-none dark:bg-yellow-400 dark:text-yellow-800">
          <AlertTitle className="text-center text-xl">
            {t("cashier.cashierEmployeeWanringTitle")}
          </AlertTitle>
          <AlertDescription className="my-5 text-center text-base font-semibold">
            {t("cashier.cashierEmployeeWarningLine1")}
            <br />
            {t("cashier.cashierEmployeeWarningLine2")}
          </AlertDescription>
        </Alert>
      </>
    );
  }

  return (
    <div className="space-y-5">
      <div className="flex items-center justify-between">
        <button
          onClick={() => setBranchModalOpen(true)}
          className="my-btn w-fit px-5 py-1"
        >
          {branch !== null
            ? t(branch.nameEN, branch.nameAR)
            : t("cashier.selectBranch")}
        </button>
        <Link to={"/cashierhistory"} className="my-btn w-fit px-5 py-1">
          {t("cashier.history")}
        </Link>
      </div>
      {branchModalOpen && (
        <CashierBranchesModal
          setSelectedBranch={setSelectedBranch}
          branches={branches}
          selectedBranch={selectedBranch}
          setBranchModalOpen={setBranchModalOpen}
        />
      )}
      <div className={`grid grid-cols-4 gap-4 ${isShowingIconsOnly ? "lg:grid-cols-[repeat(18,minmax(0,1fr))]" : "lg:grid-cols-[repeat(14,minmax(0,1fr))]"} break2lg-grid-cols-18 2xl:grid-cols-12 `}>
        <CashierNavBar setTaxesActive={setTaxesActive} />

        {/* cart */}
        <CashierCart taxActivated={taxesActive} />
      </div>
    </div>
  );
}
export default Cashier;
